import React, { useEffect, useState } from 'react';
import { StaticImage } from "gatsby-plugin-image"
import Menu  from './Menu';
import ArchiveBanner from './ArchiveBanner';
import { LocalizedLink as Link, LanguageSwitch, useT } from '../i18n';

const HeaderTab = {
  HOME: 0,
  ABOUT: 1,
  CONTACT: 2,
  FILMS: 3,
  WORK: 4
}

const Header = React.memo(() => {
    const [isOpen, setOpen] = useState(false);
    const t = useT();

    const links = (
      <>
        <Link to="/" name={HeaderTab.HOME} onClick={() => setOpen(false)} activeClassName="  border-gray-500" className={`block  lg:inline-block lg:mt-0  px-4`}>
          {t('Hjem', 'Home')}
        </Link>
        <Link to="/films" name={HeaderTab.FILMS} onClick={() => setOpen(false)}  activeClassName="border-gray-500" className={`block lg:inline-block lg:mt-0  px-4`}>
          {t('Filmer', 'Films')}
        </Link>
        <Link to="/work" name={HeaderTab.WORK} onClick={() => setOpen(false)}  activeClassName="border-gray-500" className={`block lg:inline-block lg:mt-0  px-4`}>
          {t('Oppdrag', 'Work')}
        </Link>
        <Link to="/contact" name={HeaderTab.CONTACT} onClick={() => setOpen(false)} activeClassName=" border-gray-500" className={`block  lg:inline-block lg:mt-0  px-4`}>
          <div className="hidden md:flex  rounded-sm  text-white items-center text-sm justify-center bg-tb-dark cursor-pointer" style={{height: "40px", width: "130px"}}>{t('Kontakt oss', 'Contact us')}</div>
        </Link>
        <LanguageSwitch className="hidden md:block px-4 underline" />
      </>
    )

    return <div className="relative sticky top-0 z-10 "><ArchiveBanner /><nav id="header" class="bg-tb-yellow flex items-center justify-between flex-wrap bg-teal py-3.5  mx-auto px-4">
    <Menu isOpen={isOpen} setOpen={setOpen}/>
    <Link to="/" className="md:px-8 lg:px-16 flex items-center flex-no-shrink text-tb-dark  md:mr-6">
      <StaticImage src="../images/logo.jpg" alt="The branch logo" className="h-12 w-12 mr-2"  />
      <span class="font-semibold text-lg tracking-tight">The Branch</span>
    </Link>
    <div className="md:hidden flex items-center">
      <LanguageSwitch className="text-tb-dark underline text-sm mr-3" />
      <Link to="/contact" name={HeaderTab.CONTACT} onClick={() => setOpen(false)} activeClassName="text-blue-800  border-gray-500" className={`block lg:inline-block lg:mt-0 text-tb-dark`}>
        <div className="flex  rounded-lg  text-white items-center justify-center bg-tb-dark cursor-pointer" style={{height: "40px", width: "85px"}}>{t('Kontakt', 'Contact')}</div>
      </Link>
    </div>
     <div class="hidden text-base md:flex items-center text-tb-dark">
        {links}
      </div>
  </nav>
  {isOpen && <div class={`mobile-menu filter drop-shadow pl-8 absolute bg-tb-dark z-10 w-full ${isOpen ? 'open' : ''}`}>
        <ul className="text-white">
         {links}
        </ul>
      </div>}
  </div>
});

export default Header;
